import { AbstractJsonApiService } from '@ipensii/shared/data-access-shared';
import { Exception } from '@ipensii/error/domain-error';
import { Observable } from 'rxjs';

export class ExceptionService extends AbstractJsonApiService<Exception> {
  constructor() {
    super('exceptions');
  }

  override save<T = Exception>({ resource }: { resource: T }): Observable<Exception> {
    return this.http.post<Exception>(`${this.url}`, resource);
  }
}
